import type { MappingCoverageFilters, MappingCoverageSignal } from './types'
import { authApiClient } from '~/lib/api-client'

const mappingCoverageClient = authApiClient.api.admin['sports-verifier']['mapping-coverage-signals']

async function parseJson<T>(response: Response): Promise<T> {
  if (!response.ok) {
    throw response
  }
  return response.json() as Promise<T>
}

export async function listMappingCoverageSignals(filters: MappingCoverageFilters = {}) {
  const response = await mappingCoverageClient.$get({
    query: filters,
    header: { Authorization: '' },
  })
  return parseJson<MappingCoverageSignal[]>(response)
}

export async function markMappingCoverageSignalCandidate(coverageSignalId: string) {
  const response = await mappingCoverageClient[':coverageSignalId'].candidate.$post({
    param: { coverageSignalId },
    header: { Authorization: '' },
  })
  return parseJson<MappingCoverageSignal>(response)
}
